import React, { useRef } from 'react';
import { Field } from 'formik';
import { DarkBlue, LigthGray, DarkGray } from '../../../assets/colors';

const fieldStyle = {
  background: 'rgba(246, 246, 246, 0.6)',
  border: 0,
  borderBottom: `3px solid ${DarkBlue}`,
  width: '100%',
};

const fieldDisabledStyle = {
  background:LigthGray, 
  borderBottom: `3px solid ${DarkGray}`
}

function CustomField
  ({
    name, 
    isDisabled = false, 
    fieldType = 'text',
    style,
    onBlur,
    inputType,
    value,
    onKeyPress,
    onKeyUp,
    onChange
  }) {
  
  const fieldRef = useRef()

  return (
      <Field 
        name={name}
        as={inputType}
        type={fieldType} 
        style={{
          ...fieldStyle,
          ...style,
          ...(isDisabled ? fieldDisabledStyle : ""),
          }} 
        disabled={isDisabled}
        innerRef={fieldRef}
        {...(onChange && {onChange : onChange})}
        {...(onBlur && {onBlur : onBlur})}
        {...(value && {value : value})}
        {...(onKeyUp && {onKeyUp : onKeyUp})}
        {...(onKeyPress ? {onKeyPress : onKeyPress} : {
          onKeyPress: (event) => {
            if(event.key === "Enter") {
                event.preventDefault()
                // let nextInput = document.getElementsByName(event.target.name)[0].parentElement.nextSibling.getElementsByTagName('input')[0];
                const form = fieldRef.current.closest('form');
                const submitButton = form.querySelector('.submit-button');
                const button = form.querySelector('button');
                const inputs = form.getElementsByTagName('input');
                const activeInputs = [...inputs].filter((input) => !input.disabled)

                for (let index = 0; index < inputs.length; index++) {
                  if (activeInputs[index] == document.getElementsByName(event.target.name)[0]) {
                    if (index == activeInputs.length - 1) {
                      if (submitButton != null) submitButton.click();
                      else if (button != null) button.click()
                      activeInputs[0].focus();
                      break;
                    }
                    activeInputs[index+1].focus();
                  }
                }
            }
          }
        }
        )}
      />
  );
}

export default CustomField;